import React from 'react';
import '../../styles/christmas.css';

/**
 * Snowfall component - creates animated falling snowflakes
 * Pure CSS implementation for performance
 */
const Snowfall = () => {
  // Create 15 snowflakes with different animations
  const snowflakes = Array.from({ length: 15 }, (_, i) => i);

  return (
    <div className="snowfall-container" aria-hidden="true">
      {snowflakes.map((i) => (
        <div
          key={i}
          className="snowflake"
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 10}s`,
            animationDuration: `${10 + Math.random() * 10}s`,
            opacity: Math.random() * 0.6 + 0.4,
            fontSize: `${Math.random() * 10 + 10}px`,
          }}
        >
          ❄
        </div>
      ))}
    </div>
  );
};

export default Snowfall;
